import * as tslib_1 from "tslib";
import { EditableField } from '../editable_field';
var SwitchField = /** @class */ (function (_super) {
    tslib_1.__extends(SwitchField, _super);
    function SwitchField(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'checked';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    SwitchField.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "SwitchField", "checked": this.checked });
    };
    SwitchField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return SwitchField;
}(EditableField));
export { SwitchField };
//# sourceMappingURL=switch_field.js.map